import { Autocomplete, Box, Button, Drawer, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Tooltip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { ImagePaths } from '../../../../Utility/ImagePaths'
import { withTranslation } from 'react-i18next'
import { CommonGridToolBarWithFilterText, CommonPatientDetails } from '../../../../Components/Common Components/CommonComponents'
import { AmountFormat } from '../../../../Components/CommonFunctions/CommonFunctions'
import { CurrencySymbol } from '../../../../Utility/Constants'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { localGetItem } from '../../../../Utility/Services/CacheProviderService'


function IPPaymentDueReport(props) {
    const [states, setstates] = useState({
        FilterOpen: false,
        isErrorMsg: false,
        isErrorMsgText: '',
        ipdueReportData: [],
        page: 0,
        pageSize: 10,
        isLoader: false,
        printDisable: false,
        BedList: [],
        BedList_dup: [],
        FloorList: [],
        FloorList_View: [],
        wardType: null,
        blockType: null,
        floorType: null,
        BlockList_view: [],
        BlockList: [],
        creditType: '',
    })
    const { t } = props;

    useEffect(() => {
        getIPdueReportData()
        GetBedList()
    }, [])

    const getIPdueReportData = () => {
        try {
            setstates(prev => ({
                ...prev,
                isLoader: true,
                printDisable: true,
            }))
            let Ward = states?.wardType?.ward__ward_name ? states?.wardType?.ward__ward_name : ''
            let Block = states?.blockType?.block ? states?.blockType?.block : ''
            let Floor = states?.floorType?.floor ? states?.floorType?.floor : ''
            RestAPIService.getAll(`${Serviceurls.IP_DUE_REPORT_GET}?block=${Block}&floor=${Floor}&ward=${Ward}&credit_type=${states?.creditType}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setstates(prev => ({
                            ...prev,
                            isLoader: false,
                            printDisable: false,
                            ipdueReportData: response?.data?.data || [],
                        }))
                    }
                })
                .catch((error) => {
                    setstates(prev => ({
                        ...prev,
                        isLoader: true,
                        printDisable: false,
                    }))
                    errorMessage(error.response.data?.message || error.message)
                })
        } catch (error) {
            setstates(prev => ({
                ...prev,
                isLoader: true,
                printDisable: false,
            }))
            errorMessage(error.message)
        }
    }
    const RemoveDuplicates = (Array, key) => {
        const FilteredArray = Array.reduce((accumulator, current) => {
            if (!accumulator.find((item) => item[key] === current[key])) {
                accumulator.push(current);
            }
            return accumulator;
        }, []);

        return FilteredArray
    }

    const GetBedList = () => {
        try {
            RestAPIService.getAll(Serviceurls.LEGER_REPORT_BED_AVAILABLE_GET).
                then((response) => {
                    if (response.data.status === "success") {
                        setstates(prev => ({
                            ...prev,
                            BedList: RemoveDuplicates(response.data.data, 'ward_id'),
                            BedList_dup: response.data.data,
                        }))
                    }
                    else {
                        errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    errorMessage(error.response.data?.message || error.message)
                })
        }
        catch (error) {
            errorMessage(error.message)
        }
    }

    const getIPdueReportPrint = () => {
        try {
            setstates(prev => ({
                ...prev,
                printDisable: true,
            }))
            let Ward = states?.wardType?.ward__ward_name ? states?.wardType?.ward__ward_name : ''
            let Block = states?.blockType?.block ? states?.blockType?.block : ''
            let Floor = states?.floorType?.floor ? states?.floorType?.floor : ''
            RestAPIService.getAll(`${Serviceurls.IP_DUE_REPORT_GET}?block=${Block}&floor=${Floor}&ward=${Ward}&credit_type=${states?.creditType}&export_type=pdf`)
                .then((response) => {
                    if (response) {
                        //Create a Blob from the PDF Stream
                        const file = new Blob(
                            [response.data],
                            { type: 'application/pdf' });
                        //Build a URL from the file
                        const fileURL = URL.createObjectURL(file);
                        //Open the URL on new Window
                        window.open(fileURL);
                        setstates(prev => ({
                            ...prev,
                            printDisable: false,
                        }))
                    }
                }).catch((error) => {
                    setstates(prev => ({
                        ...prev,
                        printDisable: false,
                    }))
                    errorMessage(error.response.data?.message || error.message)
                })
        } catch (error) {
            setstates(prev => ({
                ...prev,
                printDisable: false,
            }))
            errorMessage(error.message)
        }
    }

    const errorMessage = (msg) => {
        setstates(prev => ({
            ...prev,
            isErrorMsg: true,
            isErrorMsgText: msg
        }))
    }
    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
                    <Button onClick={() => { setstates(prev => ({ ...prev, FilterOpen: false })) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            options={states?.BedList}
                            getOptionLabel={(option) => (option?.ward__ward_name)}
                            value={states?.wardType}
                            onChange={(event, newValue) => {
                                setstates(prev => {
                                    const block = RemoveDuplicates(
                                        prev.BedList_dup?.filter(item =>
                                            item.ward_id === newValue?.ward_id
                                        ),
                                        'block_no_id'
                                    );

                                    const block_view = prev.BedList_dup?.filter(item =>
                                        item.ward_id === newValue?.ward_id
                                    );

                                    return {
                                        ...prev,
                                        wardType: newValue,
                                        blockType: null,
                                        floorType: null,
                                        BlockList: block,
                                        BlockList_view: block_view
                                    };
                                });
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('Select Ward')}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            disabled={states.BlockList?.length === 0}
                            options={states?.BlockList}
                            getOptionLabel={(option) => (option?.block)}
                            value={states?.BlockList?.length > 0 ? states?.blockType : null}
                            onChange={(event, newValue) => {
                                setstates(prev => {
                                    const floor = RemoveDuplicates(
                                        prev.BedList_dup?.filter(item =>
                                            item.ward_id === prev.wardType?.ward_id &&
                                            item.block_no_id === newValue?.block_no_id
                                        ),
                                        'floor'
                                    );

                                    const floor_view = prev.BedList_dup?.filter(item =>
                                        item.ward_id === prev.wardType?.ward_id &&
                                        item.block_no_id === newValue?.block_no_id
                                    );

                                    return {
                                        ...prev,
                                        blockType: newValue,
                                        floorType: null,
                                        FloorList: floor,
                                        FloorList_View: floor_view
                                    };
                                });
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('Select Block')}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            disabled={states.FloorList?.length === 0}
                            options={states?.FloorList}
                            getOptionLabel={(option) => (option?.floor)}
                            value={states?.FloorList?.length > 0 ? states?.floorType : null}
                            onChange={(event, newValue) => {
                                setstates(prev => ({
                                    ...prev,
                                    floorType: newValue,
                                })
                                )
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('Select Floor')}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <FormControl size='small' fullWidth>
                            <InputLabel id="demo-simple-select-label">{'Select Credit Type'}</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={states.creditType}
                                label="Select Credit Type"
                                onChange={(event) => {
                                    setstates(prev => ({
                                        ...prev,
                                        creditType: event.target.value
                                    }))
                                }}
                            >
                                <MenuItem value={'Patient credit'}>{'Patient Credit'}</MenuItem>
                                <MenuItem value={'Insurance credit'}>{'Insurance Credit'}</MenuItem>
                                <MenuItem value={'Corporate credit'}>{'Corporate Credit'}</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            setstates(prev => ({
                                ...prev,
                                wardType: null,
                                BlockList: [],
                                blockType: null,
                                FloorList: [],
                                floorType: null,
                                creditType: '',
                            }), () => getIPdueReportData())
                        }}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            getIPdueReportData()
                            setstates(prev => ({
                                ...prev,
                                FilterOpen: false
                            }))
                        }}
                        id="eMed_Config_btn">{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }
    const msgClose = () => {
        setstates(prev => ({
            isErrorMsg: false,
            isErrorMsgText: '',
        }))
    }
    const closeFilter = () => {
        setstates(prev => ({
            ...prev,
            FilterOpen: false,
        }))
    }
    const gridToolBar = () => {
        return (
            <Box>
                <CommonGridToolBarWithFilterText />
            </Box>

        )
    }
    states?.ipdueReportData?.forEach((element, index) => element.sno = index + 1)
    const columns = [
        {
            field: "patient_name", headerName: t("PatientDetails"), flex: 0.17,
            renderCell: (params) => (<Box component={'div'}>
                <CommonPatientDetails disablePhoto={true} data={params?.row} />
            </Box>)
        },
        {
            field: "ip_number", headerName: t("AdmissionDetails"), flex: 0.15,
            renderCell: (params) => (<Box component={'div'}>
                <Typography id='eMed_Com_Patient_Name'>
                    {params?.row?.ip_number?.length > 18 ?
                        <Tooltip placement='top' title={params?.row?.ip_number} arrow><div id='eMed_Com_Patient_Name'>{params?.row?.ip_number.slice(0, 20) + "..."}</div></Tooltip>
                        : params?.row?.ip_number ? params?.row?.ip_number : "-"}
                </Typography>
                <Typography id='eMed_Com_Patient_UhidText'>{(params?.row?.admission_date ? params?.row?.admission_date : "-")}</Typography>
            </Box>)
        },
        {
            field: "ip_total", headerName: `${t("IP")} (${CurrencySymbol})`, flex: 0.14,
            renderCell: (params) => (<Box component={'div'}>{params?.row ?
                <Box sx={{ flexDirection: 'column' }}>
                    <Typography id='eMed_Com_Patient_Name'>{`Bill : `} {params?.row?.ip_total ? AmountFormat(params?.row?.ip_total).replace(`${CurrencySymbol}`, "") : "0.00"}</Typography>
                    <Typography id='eMed_Com_Patient_UhidText'>{params?.row?.ward_name?.length > 10 ?
                        <Tooltip title={params?.row?.ward_name} placement='top' arrow><Typography id='eMed_Com_Patient_UhidText'>{`${params?.row?.ward_name.slice(0, 10) + '...'} | ${params?.row?.bed_number}`}</Typography></Tooltip> :
                        `${params?.row?.ward_name ? params?.row?.ward_name : ''} | ${params?.row?.bed_number}`}</Typography>
                </Box>
                : "-"}</Box>)
        },
        {
            field: "lab_total", headerName: `${t("Investigations")} (${CurrencySymbol})`, flex: 0.11, type: 'number',
            renderCell: (params) => (<Box component={'div'}>{params?.row?.lab_total ? AmountFormat(params?.row?.lab_total).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
        },
        // {
        //     field: "grand_total", headerName: `${t("Total")} (${CurrencySymbol})`, flex: 0.11, type: "number",
        //     renderCell: (params) => (<Box component={'div'}>{params?.row?.grand_total ? AmountFormat(params?.row?.grand_total).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
        // },
        {
            field: "receipt_total", headerName: `${t("Received Amt")} (${CurrencySymbol})`, flex: 0.11, type: "number",
            renderCell: (params) => (<Box component={'div'}>{params?.row?.receipt_total ? AmountFormat(params?.row?.receipt_total).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
        },
        ...(JSON.parse(localGetItem('Show_Pharmacy_Bills_In_FO')) ? [{
            field: "pharmacy_balance", headerName: `${t("Pharmacy")} (${CurrencySymbol})`, flex: 0.13,
            renderCell: (params) => (<Box component={'div'}>{params?.row ?
                <Box sx={{ flexDirection: 'column' }}>
                    <Typography id='eMed_Com_Patient_Name'>{"Bill: "} {params?.row?.pharmacy_bill ? AmountFormat(params?.row?.pharmacy_bill).replace(`${CurrencySymbol}`, "") : "0.00"}</Typography>
                    <Typography id='eMed_Com_Patient_UhidText'>{"RCD: "} {params?.row?.pharmacy_received ? AmountFormat(params?.row?.pharmacy_received).replace(`${CurrencySymbol}`, "") : "0.00"}</Typography>
                </Box>
                : "-"}</Box>)
        }] : []),
        {
            field: "primary_payment_type", headerName: `${t("Credit Type")}`, flex: 0.10, type: "string",
            renderCell: (params) => (params.row.primary_payment_type === 'Patient credit' ? <Box component={'div'}>{params.row.primary_payment_type ? params.row.primary_payment_type : '-'}</Box> :
                params.row.primary_payment_type === 'Insurance credit' ? <Box component={'div'}>
                    <Typography>{params.row.primary_payment_type ? params.row.primary_payment_type : '-'}</Typography>
                    {params.row.insurance_company?.length > 10 ? <Tooltip title={params.row.insurance_company} placement='top'><Typography>{params.row.insurance_company.slice(0, 10) + '...'}</Typography></Tooltip> : <Typography>{params.row.insurance_company ? params.row.insurance_company : '-'}</Typography>}
                </Box> : params.row.primary_payment_type === 'Corporate credit' ? <Box component={'div'}>
                    <Typography>{params.row.primary_payment_type ? params.row.primary_payment_type : '-'}</Typography>
                    {params.row.corporate_company?.length > 10 ? <Tooltip title={params.row.corporate_company} placement='top'><Typography>{params.row.corporate_company.slice(0, 10) + '...'}</Typography></Tooltip> : <Typography>{params.row.corporate_company ? params.row.corporate_company : '-'}</Typography>}
                </Box> : null)
        },
        {
            field: "balance", headerName: `${t("Balance")} (${CurrencySymbol})`, flex: 0.13, type: "number",
            renderCell: (params) => (<Box sx={{ color: (Math.sign(params?.row?.balance) === -1) ? 'red' : (Math.sign(params?.row?.balance) === 1) ? 'green' : '' }} component={'div'}>{params?.row?.balance ? AmountFormat(params?.row?.balance).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
        }
    ]
    return (
        <Box component={'div'} className='eMed_rts_container'>
            <Box component={"div"} className='eMed_Top_Container'>
                <Box component={"div"} className='eMed_Cards_Container'>
                </Box>
                <Box component={"div"} className='eMed_Action_Container'>
                    <Box component={"div"} className='eMed_Filter_Icon_div'>
                        <Button className='eMed_usrconf_btn' onClick={() => { setstates(prev => ({ ...prev, FilterOpen: true })) }}>
                            <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                        </Button>
                    </Box>
                    <Button className='eMed_usrconf_btn' disabled={states?.printDisable} onClick={getIPdueReportPrint}>
                        <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                    </Button>
                </Box>
            </Box>
            <Box component={'div'} className='eMed_rts_table'>
                <DataGrid
                    rows={states?.ipdueReportData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={states?.page}
                    pageSize={states?.pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Stack className='eMed_conf_nodata'>
                                {t("NoRecordsFound")}
                            </Stack>
                        )
                    }}
                    onPageChange={(newPage) => { setstates(prev => ({ ...prev, page: newPage })) }}
                    onPageSizeChange={(newPageSize) => setstates(prev => ({ ...prev, pageSize: newPageSize }))}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    disableSelectionOnClick
                    loading={states?.isLoader}
                />
            </Box>
            <Drawer
                anchor={'right'}
                open={states.FilterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {states.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={states.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
        </Box>
    )
}

export default withTranslation()(IPPaymentDueReport);